module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"cancel":"Отмена","cancelSubscription":"Отменить подписку","subscriptionCancelDialog":"Ваша подписка оплачена","subscriptionCancelDialogDate":"до {date}.","subscriptionCancelDialog2":"Если вы отмените подписку сегодня, то сможете пользоваться сервисом до указанной даты. Счёт за следующий период выставлен не будет.","subscriptionCancelDialogTitle":"Отмена подписки"}}')
  delete Component.options._Ctor
}
